<form [formGroup]="formGroup" id="step1Form">
  <div class="step1-form-container">
    <div class="row">
      <div class="nowrap-container">
        <div *ngIf="controls.name as name" class="standard-form-field name-field required-field">
          <label for="applicantName" [class.invalid]="name.touched && name.invalid">
            {{ 'PERSONAL_DATA_FORM.NAME.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              id="applicantName"
              type="text"
              maxLength="200"
              minLength="1"
              placeholder="{{ 'PERSONAL_DATA_FORM.NAME.PLACEHOLDER' | translate }}"
              [required]="true"
              [attr.aria-required]="true"
              [attr.aria-describedby]="
                name.touched && name.invalid ? 'applicantNameError applicantNameTooltip' : 'applicantNameTooltip'
              "
              [attr.aria-invalid]="name.touched && name.invalid ? 'true' : null"
              [formControl]="name" />

            <!-- TOOLTIP -->
            <app-cr-form-field-tooltip
              [id]="'applicantNameTooltip'"
              class="info-suffix-icon"
              matSuffix
              [text]="'PERSONAL_DATA_FORM.NAME.TOOLTIP' | translate">
            </app-cr-form-field-tooltip>

            <!-- ERROR -->
            <mat-error *ngIf="name.touched && name.invalid" id="applicantNameError">
              {{ name.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div *ngIf="controls.previousName as previousName" class="standard-form-field previousName-field">
          <label for="applicantPreviousName" [class.invalid]="previousName.touched && previousName.invalid">
            {{ 'PERSONAL_DATA_FORM.PREVIOUS-NAME.MAIN-LABEL' | translate }}
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              id="applicantPreviousName"
              type="text"
              maxLength="200"
              minLength="1"
              placeholder="{{ 'PERSONAL_DATA_FORM.PREVIOUS-NAME.PLACEHOLDER' | translate }}"
              [required]="false"
              [attr.aria-required]="false"
              [attr.aria-describedby]="
                previousName.touched && previousName.invalid
                  ? 'applicantPreviousNameError applicantPreviousNameTooltip'
                  : 'applicantPreviousNameTooltip'
              "
              [attr.aria-invalid]="previousName.touched && previousName.invalid ? 'true' : null"
              [formControl]="previousName" />

            <!-- TOOLTIP -->
            <app-cr-form-field-tooltip
              [id]="'applicantPreviousNameTooltip'"
              class="info-suffix-icon"
              matSuffix
              [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
            </app-cr-form-field-tooltip>

            <!-- ERROR -->
            <mat-error *ngIf="previousName.touched && previousName.invalid" id="applicantPreviousNameError">
              {{ previousName.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="nowrap-container">
        <div *ngIf="controls.surname as surname" class="standard-form-field surname-field required-field">
          <label for="applicantSurname" [class.invalid]="surname.touched && surname.invalid">
            {{ 'PERSONAL_DATA_FORM.SURNAME.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              id="applicantSurname"
              type="text"
              maxLength="200"
              minLength="1"
              placeholder="{{ 'PERSONAL_DATA_FORM.SURNAME.PLACEHOLDER' | translate }}"
              [required]="true"
              [attr.aria-required]="true"
              [attr.aria-describedby]="
                surname.touched && surname.invalid
                  ? 'applicantSurnameError applicantSurnameTooltip'
                  : 'applicantSurnameTooltip'
              "
              [attr.aria-invalid]="surname.touched && surname.invalid ? 'true' : null"
              [formControl]="surname" />

            <!-- TOOLTIP -->
            <app-cr-form-field-tooltip
              [id]="'applicantSurnameTooltip'"
              class="info-suffix-icon"
              matSuffix
              [text]="'PERSONAL_DATA_FORM.SURNAME.TOOLTIP' | translate">
            </app-cr-form-field-tooltip>

            <!-- ERROR -->
            <mat-error *ngIf="surname.touched && surname.invalid" id="applicantSurnameError">
              {{ surname.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div *ngIf="controls.previousSurname as previousSurname" class="standard-form-field previousSurname-field">
          <label for="applicantPreviousSurname" [class.invalid]="previousSurname.touched && previousSurname.invalid">
            {{ 'PERSONAL_DATA_FORM.PREVIOUS-SURNAME.MAIN-LABEL' | translate }}
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              id="applicantPreviousSurname"
              type="text"
              maxLength="200"
              minLength="1"
              placeholder="{{ 'PERSONAL_DATA_FORM.PREVIOUS-SURNAME.PLACEHOLDER' | translate }}"
              [required]="false"
              [attr.aria-required]="false"
              [attr.aria-describedby]="
                previousSurname.touched && previousSurname.invalid
                  ? 'applicantPreviousSurnameError applicantPreviousSurnameTooltip'
                  : 'applicantPreviousSurnameTooltip'
              "
              [attr.aria-invalid]="previousSurname.touched && previousSurname.invalid ? 'true' : null"
              [formControl]="previousSurname" />

            <!-- TOOLTIP -->
            <app-cr-form-field-tooltip
              [id]="'applicantPreviousSurnameTooltip'"
              class="info-suffix-icon"
              matSuffix
              [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
            </app-cr-form-field-tooltip>

            <!-- ERROR -->
            <mat-error *ngIf="previousSurname.touched && previousSurname.invalid" id="applicantPreviousSurnameError">
              {{ previousSurname.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="nowrap-container">
        <div *ngIf="controls.familyName as familyName" class="standard-form-field familyName-field">
          <label for="applicantFamilyName" [class.invalid]="familyName.touched && familyName.invalid">
            {{ 'PERSONAL_DATA_FORM.FAMILY-NAME.MAIN-LABEL' | translate }}
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              id="applicantFamilyName"
              type="text"
              maxLength="200"
              minLength="1"
              placeholder="{{ 'PERSONAL_DATA_FORM.FAMILY-NAME.PLACEHOLDER' | translate }}"
              [required]="false"
              [attr.aria-required]="false"
              [attr.aria-describedby]="
                familyName.touched && familyName.invalid
                  ? 'applicantFamilyNameError applicantFamilyNameTooltip'
                  : 'applicantFamilyNameTooltip'
              "
              [attr.aria-invalid]="familyName.touched && familyName.invalid ? 'true' : null"
              [formControl]="familyName" />

            <!-- TOOLTIP -->
            <app-cr-form-field-tooltip
              [id]="'applicantFamilyNameTooltip'"
              class="info-suffix-icon"
              matSuffix
              [text]="'PERSONAL_DATA_FORM.FAMILY-NAME.TOOLTIP' | translate"
              [icon]="'help_outline'">
            </app-cr-form-field-tooltip>

            <!-- ERROR -->
            <mat-error *ngIf="familyName.touched && familyName.invalid" id="applicantFamilyNameError">
              {{ familyName.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div *ngIf="controls.fatherName as fatherName" class="standard-form-field fatherName-field required-field">
          <label for="applicantFatherName" [class.invalid]="fatherName.touched && fatherName.invalid">
            {{ 'PERSONAL_DATA_FORM.FATHER-NAME.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              id="applicantFatherName"
              type="text"
              maxLength="200"
              minLength="1"
              placeholder="{{ 'PERSONAL_DATA_FORM.FATHER-NAME.PLACEHOLDER' | translate }}"
              [required]="true"
              [attr.aria-required]="true"
              [attr.aria-describedby]="
                fatherName.touched && fatherName.invalid
                  ? 'applicantFatherNameError applicantFatherNameTooltip'
                  : 'applicantFatherNameTooltip'
              "
              [attr.aria-invalid]="fatherName.touched && fatherName.invalid ? 'true' : null"
              [formControl]="fatherName" />

            <!-- TOOLTIP -->
            <app-cr-form-field-tooltip
              [id]="'applicantFatherNameTooltip'"
              class="info-suffix-icon"
              matSuffix
              [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
            </app-cr-form-field-tooltip>

            <!-- ERROR -->
            <mat-error *ngIf="fatherName.touched && fatherName.invalid" id="applicantFatherNameError">
              {{ fatherName.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="nowrap-container">
        <div *ngIf="controls.fatherSurname as fatherSurname" class="standard-form-field fatherSurname-field">
          <label for="applicantFatherSurname" [class.invalid]="fatherSurname.touched && fatherSurname.invalid">
            {{ 'PERSONAL_DATA_FORM.FATHER-SURNAME.MAIN-LABEL' | translate }}
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              id="applicantFatherSurname"
              type="text"
              maxLength="200"
              minLength="1"
              placeholder="{{ 'PERSONAL_DATA_FORM.FATHER-SURNAME.PLACEHOLDER' | translate }}"
              [required]="false"
              [attr.aria-required]="false"
              [attr.aria-describedby]="
                fatherSurname.touched && fatherSurname.invalid
                  ? 'applicantFatherSurnameError applicantFatherSurnameTooltip'
                  : 'applicantFatherSurnameTooltip'
              "
              [attr.aria-invalid]="fatherSurname.touched && fatherSurname.invalid ? 'true' : null"
              [formControl]="fatherSurname" />

            <!-- TOOLTIP -->
            <app-cr-form-field-tooltip
              [id]="'applicantFatherSurnameTooltip'"
              class="info-suffix-icon"
              matSuffix
              [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
            </app-cr-form-field-tooltip>

            <!-- ERROR -->
            <mat-error *ngIf="fatherSurname.touched && fatherSurname.invalid" id="applicantFatherSurnameError">
              {{ fatherSurname.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div *ngIf="controls.motherName as motherName" class="standard-form-field motherName-field required-field">
          <label for="applicantMotherName" [class.invalid]="motherName.touched && motherName.invalid">
            {{ 'PERSONAL_DATA_FORM.MOTHER-NAME.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              id="applicantMotherName"
              type="text"
              maxLength="200"
              minLength="1"
              placeholder="{{ 'PERSONAL_DATA_FORM.MOTHER-NAME.PLACEHOLDER' | translate }}"
              [required]="true"
              [attr.aria-required]="true"
              [attr.aria-describedby]="
                motherName.touched && motherName.invalid
                  ? 'applicantMotherNameError applicantMotherNameTooltip'
                  : 'applicantMotherNameError'
              "
              [attr.aria-invalid]="motherName.touched && motherName.invalid ? 'true' : null"
              [formControl]="motherName" />

            <!-- TOOLTIP -->
            <app-cr-form-field-tooltip
              [id]="'applicantMotherNameTooltip'"
              class="info-suffix-icon"
              matSuffix
              [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
            </app-cr-form-field-tooltip>

            <!-- ERROR -->
            <mat-error *ngIf="motherName.touched && motherName.invalid" id="applicantMotherNameError">
              {{ motherName.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="nowrap-container">
        <div *ngIf="controls.motherSurname as motherSurname" class="standard-form-field motherSurname-field">
          <label for="applicantMotherSurname" [class.invalid]="motherSurname.touched && motherSurname.invalid">
            {{ 'PERSONAL_DATA_FORM.MOTHER-SURNAME.MAIN-LABEL' | translate }}
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              id="applicantMotherSurname"
              type="text"
              maxLength="200"
              minLength="1"
              placeholder="{{ 'PERSONAL_DATA_FORM.MOTHER-SURNAME.PLACEHOLDER' | translate }}"
              [required]="false"
              [attr.aria-required]="false"
              [attr.aria-describedby]="
                motherSurname.touched && motherSurname.invalid
                  ? 'applicantMotherSurnameError applicantMotherSurnameTooltip'
                  : 'applicantMotherSurnameTooltip'
              "
              [attr.aria-invalid]="motherSurname.touched && motherSurname.invalid ? 'true' : null"
              [formControl]="motherSurname" />

            <!-- TOOLTIP -->
            <app-cr-form-field-tooltip
              [id]="'applicantMotherSurnameTooltip'"
              class="info-suffix-icon"
              matSuffix
              [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
            </app-cr-form-field-tooltip>

            <!-- ERROR -->
            <mat-error *ngIf="motherSurname.touched && motherSurname.invalid" id="applicantMotherSurnameError">
              {{ motherSurname.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div
          *ngIf="controls.motherMaidenName as motherMaidenName"
          class="standard-form-field motherMaidenName-field required-field">
          <label for="applicantMotherMaidenName" [class.invalid]="motherMaidenName.touched && motherMaidenName.invalid">
            {{ 'PERSONAL_DATA_FORM.MOTHER-MAIDEN-NAME.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              id="applicantMotherMaidenName"
              type="text"
              maxLength="200"
              minLength="1"
              placeholder="{{ 'PERSONAL_DATA_FORM.MOTHER-MAIDEN-NAME.PLACEHOLDER' | translate }}"
              [required]="true"
              [attr.aria-required]="true"
              [attr.aria-describedby]="
                motherMaidenName.touched && motherMaidenName.invalid
                  ? 'applicantMotherMaidenNameError applicantMotherMaidenNameTooltip'
                  : 'applicantMotherMaidenNameTooltip'
              "
              [attr.aria-invalid]="motherMaidenName.touched && motherMaidenName.invalid ? 'true' : null"
              [formControl]="motherMaidenName" />

            <!-- TOOLTIP -->
            <app-cr-form-field-tooltip
              [id]="'applicantMotherMaidenNameTooltip'"
              class="info-suffix-icon"
              matSuffix
              [text]="'PERSONAL_DATA_FORM.MOTHER-MAIDEN-NAME.TOOLTIP' | translate"
              [icon]="'help_outline'">
            </app-cr-form-field-tooltip>

            <!-- ERROR -->
            <mat-error *ngIf="motherMaidenName.touched && motherMaidenName.invalid" id="applicantMotherMaidenNameError">
              {{ motherMaidenName.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="nowrap-container">
        <div *ngIf="controls.sex as sex" class="standard-form-field sex-field required-field">
          <label for="applicantSex" [class.invalid]="sex.touched && sex.invalid">
            {{ 'PERSONAL_DATA_FORM.SEX.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <mat-select
              [formControl]="sex"
              id="applicantSex"
              panelClass="standard-select"
              [placeholder]="'PERSONAL_DATA_FORM.SEX.PLACEHOLDER' | translate"
              [attr.aria-describedby]="sex.touched && sex.invalid ? 'applicantSexError' : null"
              [attr.aria-invalid]="sex.touched && sex.invalid ? 'true' : null"
              required>
              <mat-option *ngFor="let item of selectsValues.SEX" [value]="item.value">
                {{ item.label }}
              </mat-option>
            </mat-select>

            <!-- ERROR -->
            <mat-error *ngIf="sex.touched && sex.invalid" id="applicantSexError">
              {{ sex.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div *ngIf="controls.dateOfBirth as dateOfBirth" class="standard-form-field dateOfBirth-field required-field">
          <label for="applicantDateOfBirth" [class.invalid]="dateOfBirth.touched && dateOfBirth.invalid">
            {{ 'PERSONAL_DATA_FORM.DATE-OF-BIRTH.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline" (click)="picker.open()">
            <input
              matInput
              (focus)="picker.open()"
              id="applicantDateOfBirth"
              #applicantDateOfBirth
              [matDatepicker]="picker"
              placeholder="{{ 'PERSONAL_DATA_FORM.DATE-OF-BIRTH.PLACEHOLDER' | translate }}"
              [min]="minValidDate"
              [max]="maxValidDate"
              [readonly]="true"
              [required]="true"
              [attr.aria-required]="true"
              [attr.aria-describedby]="dateOfBirth.touched && dateOfBirth.invalid ? 'applicantDateOfBirthError' : null"
              [attr.aria-invalid]="dateOfBirth.touched && dateOfBirth.invalid ? 'true' : null"
              [formControl]="dateOfBirth" />

            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
              aria-label="{{ 'COMMON.ACTION.OPEN_DATE_PICKER' | translate }}">
            </mat-datepicker-toggle>

            <mat-datepicker
              #picker
              [startView]="'month'"
              [startAt]="'1985'"
              [calendarHeaderComponent]="pickerHeader"
              (closed)="applicantDateOfBirth.blur()">
            </mat-datepicker>

            <!-- ERROR -->
            <mat-error *ngIf="dateOfBirth.touched && dateOfBirth.invalid" id="applicantDateOfBirthError">
              {{ dateOfBirth.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="nowrap-container">
        <div
          *ngIf="controls.placeOfBirth as placeOfBirth"
          class="standard-form-field placeOfBirth-field required-field">
          <label for="applicantPlaceOfBirth" [class.invalid]="placeOfBirth.touched && placeOfBirth.invalid">
            {{ 'PERSONAL_DATA_FORM.PLACE-OF-BIRTH.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              id="applicantPlaceOfBirth"
              type="text"
              maxLength="200"
              minLength="1"
              placeholder="{{ 'PERSONAL_DATA_FORM.PLACE-OF-BIRTH.PLACEHOLDER' | translate }}"
              [required]="true"
              [attr.aria-required]="true"
              [attr.aria-describedby]="
                placeOfBirth.touched && placeOfBirth.invalid
                  ? 'applicantPlaceOfBirthError applicantPlaceOfBirthTooltip'
                  : 'applicantPlaceOfBirthTooltip'
              "
              [attr.aria-invalid]="placeOfBirth.touched && placeOfBirth.invalid ? 'true' : null"
              [formControl]="placeOfBirth" />

            <!-- TOOLTIP -->
            <app-cr-form-field-tooltip
              [id]="'applicantPlaceOfBirthTooltip'"
              class="info-suffix-icon"
              matSuffix
              [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
            </app-cr-form-field-tooltip>

            <!-- ERROR -->
            <mat-error *ngIf="placeOfBirth.touched && placeOfBirth.invalid" id="applicantPlaceOfBirthError">
              {{ placeOfBirth.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="standard-form-field countryOfBirth-field required-field">
          <app-country-select
            class="country-select"
            [fieldControl]="controls.countryOfBirth"
            [fieldKey]="'countryOfBirth'"
            [isRequired]="true"
            [fieldLabelKey]="'COUNTRY-OF-BIRTH'">
          </app-country-select>
        </div>
      </div>
      <div class="nowrap-container">
        <div class="standard-form-field citizenship-field required-field">
          <!-- Filtering out id: 616 -> Poland. Person that has Polish citizenship cannot apply for temp. permit -->
          <app-country-select
            class="country-select"
            [fieldControl]="controls.citizenship"
            [fieldKey]="'citizenship'"
            [isRequired]="true"
            [filterOutIds]="[616]"
            [fieldLabelKey]="'CITIZENSHIP'">
          </app-country-select>
        </div>
        <div
          *ngIf="controls.passportNumber as passportNumber"
          class="standard-form-field passportNumber-field required-field">
          <label for="applicantPassportNumber" [class.invalid]="passportNumber.touched && passportNumber.invalid">
            {{ 'PERSONAL_DATA_FORM.PASSPORT-NUMBER.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              id="applicantPassportNumber"
              type="text"
              maxLength="200"
              minLength="1"
              placeholder="{{ 'PERSONAL_DATA_FORM.PASSPORT-NUMBER.PLACEHOLDER' | translate }}"
              [required]="true"
              [attr.aria-required]="true"
              [attr.aria-describedby]="
                passportNumber.touched && passportNumber.invalid
                  ? 'applicantPassportNumberError applicantPassportNumberTooltip'
                  : 'applicantPassportNumberTooltip'
              "
              [attr.aria-invalid]="passportNumber.touched && passportNumber.invalid ? 'true' : null"
              [formControl]="passportNumber"
              (keydown.Tab)="lastFieldTabPressed.emit(); $event.preventDefault(); $event.stopPropagation()" />

            <!-- TOOLTIP -->
            <app-cr-form-field-tooltip
              [id]="'applicantPassportNumberTooltip'"
              class="info-suffix-icon"
              matSuffix
              [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
            </app-cr-form-field-tooltip>

            <!-- ERROR -->
            <mat-error *ngIf="passportNumber.touched && passportNumber.invalid" id="applicantPassportNumberError">
              {{ passportNumber.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="mode === 'employee'">
      <div class="standard-form-field nationality-field required-field">
        <app-nationality-select
          class="country-select"
          [fieldControl]="controls.nationality"
          [fieldKey]="'nationality'"
          [isRequired]="true"
          [fieldLabelKey]="'NATIONALITY'">
        </app-nationality-select>
      </div>
    </div>
  </div>
</form>
